import { string, number } from 'prop-types';

export default {
  PRICE: {
    id: string,
    value: number,
    currency: string,
    symbol: string,
    type: string,
    title: string,
    caption: string,
  },

  SESSION: {
    userId: string,
  },
};
